<div class="form-search">
  <search-table-filter [formControl]="searchControl"></search-table-filter>
</div>
